import PropTypes from 'prop-types';

export const UserPropTypes = {
  authenticationId: PropTypes.string,
  isFirstLogin: PropTypes.bool,
  mustChangePassword: PropTypes.bool,
  passwordExpirationDays: PropTypes.number,
  showPasswordExpirationWarning: PropTypes.bool,
  showLicenseWarning: PropTypes.bool,
  isSecurityAnsNeeded: PropTypes.bool,
  isEmailOTPDisallowed: PropTypes.bool,
  lastLoginTime: PropTypes.string,
  userName: PropTypes.string,
  userCode: PropTypes.string,
  customerCode: PropTypes.string,
  termsAndConditions: PropTypes.bool,
  name: PropTypes.string,
  lastLogin: PropTypes.string,
  token: PropTypes.string
};

export const UserShape = PropTypes.shape(UserPropTypes);

export const UserDefaultProps = {
  authenticationId: null,
  isFirstLogin: null,
  mustChangePassword: null,
  passwordExpirationDays: null,
  showPasswordExpirationWarning: null,
  showLicenseWarning: null,
  isSecurityAnsNeeded: null,
  isEmailOTPDisallowed: null,
  lastLoginTime: null,
  userName: null,
  userCode: null,
  customerCode: null,
  termsAndConditions: null,
  name: null,
  lastLogin: null,
  token: null
};
